module.exports = __webpack_public_path__ + "312e4d6780b57102cec252ba0ba16f4f.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics2/2.png
// module id = 300
// module chunks = 0